export type StepId = 'profile' | 'drivers' | 'dispatchers' | 'driverApp';

export interface OnboardingStepDef {
  id: StepId;
  number: number;
  title: string;
  subtitle: string;
}

export const STEPS: OnboardingStepDef[] = [
  { id: 'profile', number: 1, title: 'Review Profile', subtitle: 'Business name and location' },
  { id: 'drivers', number: 2, title: 'Add Drivers', subtitle: 'Invite your team' },
  { id: 'dispatchers', number: 3, title: 'Add Dispatchers', subtitle: 'Invite admins' },
  { id: 'driverApp', number: 4, title: 'Team Member Apps', subtitle: 'Installation links' },
];
